/* Universal javascript */

// Get the global css
import '/src/css/app.css';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';

// Plyr CSS
import 'plyr/dist/plyr.css';

// Alpine.js
import Alpine from 'alpinejs';
import screenStore from './stores/screen';
import cartStore from './stores/cart';
import teleportResponsive from './directives/teleport-responsive';

import heroComponent from './components/home/hero.js';
import tabsComponent from './components/tabs.js';
import swiperComponent from './components/swiper.js';
import plyrComponent from './components/plyr.js';
import oilSelectorComponent from './components/oil-selector.js';
import distributorFormComponent from './components/distributor-form.js';
import contactsFormComponent from './components/contacts-form.js';
import helloTallowCampaignPageFormComponent from './components/hello-tallow-campaign-page-form.js';
import protectedPageFormComponent from './components/protected-page-form.js';
import tallowCalculatorComponent from './components/tallow-calculator.js';
import { tradeShowCalculatorComponent } from './components/trade-show-calculator.js';

Alpine.plugin(teleportResponsive);
Alpine.store('screen', screenStore);
Alpine.store('cart', cartStore);
Alpine.data('hero', heroComponent);
Alpine.data('tabs', tabsComponent);
Alpine.data('swiper', swiperComponent);
Alpine.data('plyr', plyrComponent);
Alpine.data('oilSelector', oilSelectorComponent);
Alpine.data('oilSelectorTool', oilSelectorComponent);
Alpine.data('distributorForm', distributorFormComponent);
Alpine.data('contactsForm', contactsFormComponent);
Alpine.data('helloTallowCampaignPageForm', helloTallowCampaignPageFormComponent);
Alpine.data('protectedPageForm', protectedPageFormComponent);
Alpine.data('tallowCalculator', tallowCalculatorComponent);
Alpine.data('tradeShowCalculator', tradeShowCalculatorComponent);

Alpine.start();


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}
